import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import * as React from 'react';
import { FormField, Select } from '@cian/ui-kit';
import { useField } from 'formik';
import { themeContextObj } from '../../utils';
import { jsx as _jsx } from "react/jsx-runtime";
export var SelectFieldContainer = function SelectFieldContainer(props) {
  var _props$inputNameAttri;
  var _useField = useField({
      name: props.name
    }),
    _useField2 = _slicedToArray(_useField, 3),
    field = _useField2[0],
    meta = _useField2[1],
    helpers = _useField2[2];
  var hasError = Boolean(meta.touched && meta.error);
  var _React$useContext = React.useContext(themeContextObj),
    fieldsSize = _React$useContext.fieldsSize;
  var onChange = function onChange(value) {
    helpers.setValue(value.toString(), false);

    /** При вводе в поле ошибка будет сбрасываться, если есть */
    if (hasError) {
      /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
      helpers.setError(undefined);
    }
  };
  if (!props.selectOptions) {
    return null;
  }
  return /*#__PURE__*/_jsx(FormField, {
    label: props.label,
    errorMessage: hasError ? meta.error : null,
    withoutMargin: true,
    children: /*#__PURE__*/_jsx(Select, {
      name: (_props$inputNameAttri = props.inputNameAttribute) !== null && _props$inputNameAttri !== void 0 ? _props$inputNameAttri : props.name,
      autoFocus: props.autoFocus,
      placeholder: props.placeholder || 'Выбрать',
      options: props.selectOptions,
      invalid: hasError,
      onChange: onChange,
      value: field.value,
      "data-testid": "select_input",
      width: "100%",
      size: fieldsSize || 'M'
    })
  });
};
SelectFieldContainer.displayName = 'SelectFieldContainer';